import { Injectable } from '@angular/core';
import { ApiService } from './api.service';
import { AppConstants } from '../@core/common/constants/app-constants';
@Injectable({
    providedIn: 'root',
})
export class OfficeService {
    constructor(private apiService: ApiService) {

    }

    public getOfficesByFilter(queryString: string) {
        return this.apiService.httpGet(AppConstants.GET_OFFICES_BY_FILTER + queryString);
    }

    public getOfficeDetail(queryString: string) {
        return this.apiService.httpGet(AppConstants.GET_OFFICE_DETAIL + queryString);
    }

    public updateOffice(obj: FormData) {
        return this.apiService.httpPost(AppConstants.UPDATE_OFFICE, obj);
    }

    public createOffice(obj: FormData) {
        return this.apiService.httpPost(AppConstants.CREATE_OFFICE, obj);
    }

    public getActiveOffice() {
        return this.apiService.httpGet(AppConstants.GET_ALL_OFFICES_ACTIVE);
    }
}
